import React from 'react';
import { Hero } from './components/Hero';
import { EmpathySection } from './components/EmpathySection';
import { EsterStory } from './components/EsterStory';
import { ProductReveal } from './components/ProductReveal';
import { Timeline } from './components/Timeline';
import { IncludedFeatures } from './components/IncludedFeatures';
import { ForYou } from './components/ForYou';
import { Author } from './components/Author';
import { Testimonials } from './components/Testimonials';
import { OfferStack } from './components/OfferStack';
import { Guarantee } from './components/Guarantee';
import { Urgency } from './components/Urgency';
import { FinalCTA } from './components/FinalCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-navy-900 font-sans text-cream-300 overflow-x-hidden" data-id="element-0">
      <main className="mx-auto w-full max-w-2xl bg-navy-900 shadow-2xl shadow-black/50 min-h-screen border-x border-gold-500/5" data-id="element-1">
        <Hero data-id="element-2" />
        <EmpathySection data-id="element-3" />
        <EsterStory data-id="element-4" />
        <ProductReveal data-id="element-5" />
        <Timeline data-id="element-6" />
        <IncludedFeatures data-id="element-7" />
        <ForYou data-id="element-8" />
        <Author data-id="element-9" />
        <Testimonials data-id="element-10" />
        <OfferStack data-id="element-11" />
        <Guarantee data-id="element-12" />
        <Urgency data-id="element-13" />
        <FinalCTA data-id="element-14" />
        <FAQ data-id="element-15" />
        <Footer data-id="element-16" />
      </main>
      <StickyCTA data-id="element-17" />
    </div>;
}